<vdw-header [title]="getPlanningItemTypeLabel() | bmsTranslate" svgIcon="planning-blue" [canShowClose]="true" (closeEvent)="close()"></vdw-header>
<article class="sidebar-content flex-row flex-1">
  <div class="flex-column flex-100">
    <app-disabled-form-input [label]="'GENERAL.DATETIME.START_DATE' | bmsTranslate" [value]="planningItem.startDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY'"></app-disabled-form-input>

    <app-disabled-form-input [label]="'GENERAL.DATETIME.END_DATE' | bmsTranslate" [value]="planningItem.endDate | DateTime: 'DATETIME_MED_WITH_WEEKDAY'"></app-disabled-form-input>

    <ng-container *ngIf="isPlanningItemOfTypeRun()">
      <ng-container *ngIf="isPlanningItemCarpetRun()">
        <app-disabled-form-input [label]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1}" [value]="getMachineQualityLabel()"></app-disabled-form-input>

        <app-disabled-form-input [label]="'TEXTILE_DATA.CREEL.CREEL' | bmsTranslate: {count: 1}" [value]="getCreelLabel()"> </app-disabled-form-input>
      </ng-container>
      <ng-container *ngIf="isPlanningItemWeavingRun()">
        <app-disabled-form-input [label]="'TEXTILE_DATA.WEAVE_PRODUCT.WEAVE_PRODUCT' | bmsTranslate: {count: 1}" [value]="getWeavePatternLabel()"> </app-disabled-form-input>
      </ng-container>

      <app-production-orders-list [planningOrders]="getPlanningOrders()" [viewOnly]="true" (selectPlanningOrder)="onPlanningOrderSelected($event)"></app-production-orders-list>
    </ng-container>
  </div>
</article>
<footer class="sidebar-footer flex-row flex-center gap-16" *ngIf="canShowActions()">
  <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'MACHINE.ACTIONS.CREATE_PRODUCTION_ORDER' | bmsTranslate" (click)="createProductionOrderForRun()">
    <mat-icon svgIcon="add-prod-order"></mat-icon>
  </button>
  <button *ngIf="canDeletePlanningItem()" mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'GENERAL.ACTIONS.DELETE' | bmsTranslate" (click)="delete()">
    <mat-icon svgIcon="trash"></mat-icon>
  </button>
</footer>
